export default "__VITE_ASSET__CFTq8jxJ__"